<template>
  <div class="h-full overflow-y-auto">
    <div id="decor_assets" class="grid gap-2 h-full justify-between pr-1">
      <template v-for="asset in assets">
        <c-asset-download @onClick="activeAsset=asset"
                          @onClickDownload="downloadImage(asset.asset, asset.filename)"
                          v-if="getAsset(asset.type)" :title="asset.type"
                          :url="asset.assetLow"></c-asset-download>
      </template>
    </div>

    <c-asset-popup v-if="activeAsset!== null" @onClose="activeAsset = null"
                   :asset="activeAsset.assetLow"
                   :name="activeAsset.filename"
                   @onClickDownload="downloadImage(activeAsset.asset, activeAsset.filename); activeAsset=null"></c-asset-popup>
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import AssetDownload from "../AssetDownload";
import AssetPopup from "../../../templates/AssetPopup";
import download from "../../../mixins/download";

export default {
  name: "DecorDownloadForm",
  components: {
    'c-asset-download': AssetDownload,
    'c-asset-popup': AssetPopup,
  },
  mixins: [getTranslation, download],

  props: {
    assets: {required: true},
    decor: {required: true},
  },

  data() {
    return {
      activeAsset: null,
    }
  },

  methods: {
    getAsset(key) {
      return this.assets.find((asset) => {
        return asset.type === key
      })
    },
  }
}
</script>

<style scoped>
#decor_assets {
  grid-template-columns: repeat(auto-fill, 350px);
  height: 100% !important;
}
</style>
